interface Props {
  activeColor: string;
}
const OperatorsIcon = (props: Props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C7.58 3 4 6.58 4 11V15C4 16.1 4.9 17 6 17H8V11H6C6 7.69 8.69 5 12 5C15.31 5 18 7.69 18 11H16V17H18C19.1 17 20 16.1 20 15V11C20 6.58 16.42 3 12 3Z"
        fill={props.activeColor}
      />
      <path
        d="M9 19H15C15 20.1 14.1 21 13 21H11C9.9 21 9 20.1 9 19Z"
        fill={props.activeColor}
      />
    </svg>
  );
};

export default OperatorsIcon;
